import React from 'react';
import { Button } from './Button';
import { BoxIcon } from 'lucide-react';
interface EmptyStateProps {
  icon: BoxIcon;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}
export function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction
}: EmptyStateProps) {
  return <div className="flex flex-col items-center justify-center py-12 px-4 text-center" data-id="element-1300">
      <div className="h-16 w-16 bg-white/5 rounded-full flex items-center justify-center mb-4" data-id="element-1301">
        <Icon className="h-8 w-8 text-white/40" data-id="element-1302" />
      </div>
      <h3 className="text-lg font-semibold text-white mb-2" data-id="element-1303">{title}</h3>
      <p className="text-white/50 max-w-sm mb-6" data-id="element-1304">{description}</p>
      {actionLabel && onAction && <Button onClick={onAction} variant="secondary" data-id="element-1305">
          {actionLabel}
        </Button>}
    </div>;
}